/**
 * @fileoverview DELETE handler for the "/databricks_deltashares/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteDeltasharesCacheKeys } from "./constants";
import type { DeleteDeltasharesProps, MutateDeltasharesResult } from "./types";

export const deleteDeltashares = reactQueryMutationAdapter(
  deleteDeltasharesCacheKeys,
  (props: DeleteDeltasharesProps): Promise<MutateDeltasharesResult> => {
    return fetch(
      `/databricks_deltashares/${props.appGroupId}`,
      "DELETE",
      {
        sharing_id: props.sharing_id,
        ...(props.tier != null && { tier: props.tier }),
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
